import { render, staticRenderFns } from "./SetTagTypeInMachine.vue?vue&type=template&id=6daa9e66"
import script from "./SetTagTypeInMachine.vue?vue&type=script&lang=js"
export * from "./SetTagTypeInMachine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports